// Limited-time $6.95 banner — only shown to logged-out visitors.
// As soon as a user signs in (paid OR unpaid), the banner is hidden.
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function LimitedTimeBanner() {
  const { user, loading } = useAuth();
  // Hide while auth state is loading (prevents banner flash for logged-in users)
  // Hide for ANY signed-in user — paid or not, they shouldn't see the public promo
  if (loading || user) return null;

  return (
    <div
      className="w-full bg-gradient-to-r from-[#D4AF37]/15 via-[#D4AF37]/25 to-[#D4AF37]/15 border-b border-[#D4AF37]/40 backdrop-blur-md"
      data-testid="limited-time-banner"
    >
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center justify-center gap-3 text-center flex-wrap">
        <Sparkles className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
        <span className="text-xs sm:text-sm text-[#F5E6B3]">
          <span className="font-semibold text-[#D4AF37]">Limited time</span> — Join OSRR for just{" "}
          <span className="font-bold text-[#D4AF37]">$6.95</span>. Lifetime access to the global
          rights registry · multi-currency checkout via Stripe.
        </span>
        <Link
          to="/register"
          className="text-xs font-semibold text-[#D4AF37] hover:text-[#F5E6B3] inline-flex items-center gap-1 underline underline-offset-2"
          data-testid="limited-time-cta"
        >
          Claim my $6.95 access <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    </div>
  );
}
